
// https://cdn.shopify.com/s/files/1/0420/7994/4863/t/105/assets/mazing-ar-icon.png?v=1742976449

let currentProduct;
let initializing = false;

const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (typeof mazing === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});

const waitForElement = (selector, timeout = 55000) => {
    return new Promise((resolve) => {
        const interval = 50;
        let elapsedTime = 0;

        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                resolve(element);
            } else if ((elapsedTime += interval) >= timeout) {
                clearInterval(checkInterval);
                resolve();
            }
        }, interval);
    });
};


// START A/B SECTION

await waitForMazingFunction;
await waitForElement('.buy-buttons button[type="submit"]');

mazingSetAB({
    enabled: true,
    addToCartListeners: (callback) => {

        document.querySelector('.buy-buttons button[type="submit"]').addEventListener('click', () => {
            console.log('MAZING: addToCartClicked A/B');
            callback();
        });

        return true;
    }
});

// END A/B SECTION

const initializeMazing = async () => {
    await mazing({
        customerName: 'MYMAGICCARPET',
        buttonConfiguration: {
            customStyle: `
                .mazing-button-container {
                    padding-left: 15px;
                    padding-right: 15px;
                    width: 100%;
                    position: absolute;
                    bottom: 104px;
                    left: 50%;
                    transform: translateX(-50%);
                    justify-content: start;
                    z-index: 1;
                }
                
                .mazing-ar-btn-icon,
                .mazing-threed-btn-icon {
                    filter: brightness(0) saturate(100%) invert(100%);
                    width: fit-content !important;
                    margin: 0 !important;
                }
                
                .mazing-threed-btn,
                .mazing-ar-btn { 
                    background: #299595 !important;        
                    box-shadow: none !important;
                    display: flex;
                    justify-content: space-around; 
                    gap: 10px;
                    padding-left: 24px;
                    border-radius: 5px;
                    padding-right: 24px;
                    position: relative;
                    overflow: hidden;
                    z-index: 1;
                }
                
                .mazing-threed-btn-text,
                .mazing-ar-btn-text{
                    font-weight: 600;
                    color: white;
                }
                
                .mazing-threed-btn::before,
                .mazing-ar-btn::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 100%;
                    width: 100%;
                    background: rgba(255, 255, 255, 0.15);
                    transform: scaleX(0);
                    transform-origin: left;
                    transition: transform 0.3s ease;
                    z-index: -1;
                }
                
                .mazing-threed-btn:hover::before,
                .mazing-ar-btn:hover::before {
                    opacity: 1 !important;
                    transform: scaleX(1);
                }
                
                @media (max-width: 500px) {
                    .mazing-threed-btn-text,
                    .mazing-ar-btn-text{
                        display: none !important;
                    }
                    
                   .mazing-button-container {
                        bottom: 80px;
                   }
                    
                   .mazing-ar-btn-icon,
                   .mazing-threed-btn-icon {
                        height: 36px;
                   }
                   
                   .mazing-threed-btn,
                   .mazing-ar-btn { 
                        padding: 8px;
                        height: 60px;
                        width: 60px;
                        border-radius: 50%;
                   }
                }
            `,
            placementSelector: (() => {
                return '.product-gallery__image-list';
            })(),
            threedBtn: {
                enabled: false,
                icon: true,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        "en": "View in 3D",
                        "de": "In 3D ansehen",
                        "fr": "Voir en 3D",
                        "es": "Ver en 3D"
                    };

                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            },
            arBtn: {
                enabled: true,
                icon: false,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        "en": "View in Room",
                        "de": "Im Raum anzeigen",
                        "fr": "Voir dans votre espace",
                        "es": "Ver en tu espacio"
                    };

                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            }
        },
        getSKU: getCurrentSKU
    });

    console.log('Mazing initialized.');
};

const getCurrentSKU = () => {
    const url = window.location.href;
    const parts = url.split("/");
    const product = parts.filter(part => part.trim() !== '').pop();
    const productParts = product.split('?');

    currentProduct = `${productParts[0]}`;
    let finalSKU = currentProduct.toLowerCase();

    const selectedInput = document.querySelector('input[type="radio"][name^="product-form"]:checked');
    if (selectedInput) {
        const label = selectedInput.closest('label');
        const variantText = label ? label.textContent.trim() : '';
        const cleanedText = variantText.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
        finalSKU += cleanedText;
    }

    console.log('Final SKU:', finalSKU);
    return finalSKU;
};


const attachOptionListeners = () => {
    const optionInputs = document.querySelectorAll('input[type="radio"][name^="product-form"]');

    optionInputs.forEach(input => {
        input.addEventListener("change", async () => {
            console.log('Variant radio changed, reinitializing...');
            setTimeout(async () => {
                await initializeScript();
            }, 700);
        });
    });
};


const addCustomIconToMazingButton = () => {
    const arButton = document.querySelector('.mazing-ar-btn');

    if (arButton) {
        const existingIcon = arButton.querySelector('.mazing-ar-btn-icon');
        if (!existingIcon) {
            const iconImg = document.createElement('img');
            iconImg.src = "https://cdn.shopify.com/s/files/1/0420/7994/4863/t/105/assets/mazing-ar-icon.png?v=1742976449";
            iconImg.alt = "View in Room";
            iconImg.classList.add("mazing-ar-btn-icon");
            iconImg.style.height = "36px";
            iconImg.style.marginLeft = "10px";

            arButton.prepend(iconImg);
        }
    }
};

const initializeScript = async () => {
    if (initializing) return;
    initializing = true;

    try {
        await waitForMazingFunction;
        console.log('mazingProjectAvailable is now available');

        document.querySelectorAll('.mazing-button-container').forEach(btn => btn.remove());
        document.querySelectorAll('#mazing-popup-container').forEach(popup => popup.remove());

        await initializeMazing();
        attachOptionListeners();
        addCustomIconToMazingButton();

        // document.getElementById('mazing-popup-container').style.zIndex = '99999999';
        // document.querySelector('.shopify-section.shopify-section-group-header-group.cc-header').style.zIndex = '999999999';

        console.log('Initialized successfully.');
    } catch (error) {
        console.error('Initialization failed:', error);
    } finally {
        initializing = false;
    }
};

initializeScript();
